/**
 * Module appels — généré depuis le plan directeur GÉCÉRAM CRM (2026-07-28).
 * S'intègre par le registre : aucun fichier du noyau modifié.
 */
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";

const mod: ModuleDef = {
  id: "appels",
  label: "Appels",
  icon: "i-phone",
  navGroup: "communications",
  navOrder: 40,
  rolesRequis: [],
  routes: [{ path: "/appels", component: lazy(() => import("./routes/Index")) }],
};

export default mod;
